"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[87778],{

/***/ 87778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pro_tools_Seasonality; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/LandingPage/index.ts + 8 modules
var LandingPage = __webpack_require__(55781);
// EXTERNAL MODULE: ./src/features/pro-tools/constants.ts
var constants = __webpack_require__(23443);
;// CONCATENATED MODULE: ./src/features/pro-tools/Seasonality/content.ts
var seasonalityContents = [
    {
        title: "Lebih dari 15 Tahun Price History",
        description: "Manfaatkan tren pergerakan harga pada setiap bulan sampai dengan lebih dari 15 tahun yang lalu. Karena ada bulan yang lebih baik dari bulan-bulan lainnya pada setiap tahun.",
        image: "Seasonality_15_Years_Blue.jpg"
    },
    {
        title: "Probabilitas Kenaikan",
        description: "Probabilitas kenaikan untuk setiap bulannya akan otomatis terhitung. Hint: $IHSG 100% positif pada bulan Desember selama 16 tahun terakhir.",
        image: "Seasonality_Probabilitas_Blue.jpg"
    }, 
];
/* harmony default export */ var content = (seasonalityContents);

;// CONCATENATED MODULE: ./src/features/pro-tools/Seasonality/index.tsx




function Seasonality() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* PageHeader */.mr, {
                title: "Seasonality",
                description: "Prediksi dan manfaatkan momentum tren harga saham berdasarkan waktu"
            }),
            content.map(function(content, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* SectionBrowser */.Dr, {
                    title: content.title,
                    image: "".concat(constants/* ASSET_URL */.Z).concat(content.image),
                    description: content.description,
                    reverse: index % 2 === 0
                });
            })
        ]
    });
}
/* harmony default export */ var pro_tools_Seasonality = (Seasonality);


/***/ })

}]);